import React from 'react';
import { Calendar, Info, X } from 'lucide-react';
import DoctorAvatar from './DoctorAvatar';

export default function DoctorProfileModal({ doctor, primary, onClose, onBook }) {
  if (!doctor) return null;

  return (
    <div
      className="fixed inset-0 z-50 flex items-end sm:items-center justify-center p-0 sm:p-4"
      role="dialog"
      aria-modal="true"
      aria-labelledby="doctor-profile-title"
      data-testid="doctor-profile-modal"
    >
      <button type="button" className="absolute inset-0 bg-black/70 backdrop-blur-sm" aria-label="Close" onClick={onClose} />
      <div className="relative w-full sm:max-w-lg rounded-t-3xl sm:rounded-3xl border border-white/10 bg-zinc-900 shadow-2xl overflow-hidden">
        <div className="h-2 w-full" style={{ background: primary }} />
        <button
          type="button"
          onClick={onClose}
          className="absolute top-4 right-4 h-8 w-8 rounded-full bg-white/10 text-zinc-300 hover:bg-white/15 flex items-center justify-center"
          aria-label="Close profile"
        >
          <X className="h-4 w-4" />
        </button>
        <div className="p-6 sm:p-8">
          <div className="flex items-start gap-4">
            <DoctorAvatar doctor={doctor} primary={primary} size="xl" />
            <div className="min-w-0 pt-1">
              <p className="text-[11px] uppercase tracking-[0.18em] text-zinc-500">{doctor.category}</p>
              <h3 id="doctor-profile-title" className="text-xl font-bold text-zinc-50 mt-1 leading-tight" style={{ fontFamily: 'Manrope' }}>
                {doctor.name}
              </h3>
              {doctor.title && <p className="text-sm text-zinc-400 mt-1">{doctor.title}</p>}
              <p className="text-sm font-medium mt-2" style={{ color: primary }}>{doctor.specialization}</p>
              {doctor.qualifications ? (
                <p className="text-xs text-zinc-500 mt-1">{doctor.qualifications}</p>
              ) : null}
            </div>
          </div>
          {doctor.bio && (
            <p className="mt-5 text-[14px] text-zinc-300 leading-relaxed border-t border-white/8 pt-5">
              {doctor.bio}
            </p>
          )}
          <div className="mt-6 flex flex-col sm:flex-row gap-2">
            {doctor.bookable !== false && (
              <button
                type="button"
                onClick={() => onBook(doctor)}
                className="flex-1 inline-flex items-center justify-center gap-2 px-4 py-3 rounded-full font-semibold text-white"
                style={{ background: primary }}
                data-testid="modal-book-doctor"
              >
                <Calendar className="h-4 w-4" /> Book appointment
              </button>
            )}
            <button
              type="button"
              onClick={onClose}
              className="px-4 py-3 rounded-full border border-white/15 text-sm text-zinc-300 hover:bg-white/5"
            >
              Close
            </button>
          </div>
          <p className="mt-4 text-[11px] text-zinc-600 flex items-center gap-1.5">
            <Info className="h-3 w-3" />
            Based on{' '}
            <a
              href="https://hospital.iith.ac.in/hospital-personnel/"
              target="_blank"
              rel="noreferrer"
              className="underline hover:text-zinc-400"
            >
              IIT Hyderabad Hospital personnel
            </a>
          </p>
        </div>
      </div>
    </div>
  );
}
